import { ProductAggregatedStatPobraniaSum } from "@/store/modules/statsPobrania/types";


export class State {
    aggregatedStatsPobraniaSumUpdating: boolean = false;
    aggregatedStatsPobraniaSum: Array<ProductAggregatedStatPobraniaSum> = [];
    aggregatedStatsPobraniaSumBuffer: Array<ProductAggregatedStatPobraniaSum> = [];

    aggregatedStatsPobraniaLoading: boolean = false;
    aggregatedStatsPobrania: Array<object> = [];
    aggregatedStatsPobraniaCurrentPage: number = 1;
    aggregatedStatsPobraniaTotal: number = 0;

    detailedStatsPobraniaLoading: boolean = false;
    detailedStatsPobrania: Array<object> = [];
}


